import {
    createNotificationComponent,
    INotificationProperties, Notification,
} from '@vfde-brix/notification';
import {maletsoScan} from 'Helper/matelsoHelper';

/**
 * Multi-Picker BRIX component
 * @param action
 * @param container
 */
export const mountDefaultNotification = (container: string) => {

    const elNotification = document.getElementById(container);

    return createNotificationComponent(
        elNotification,
        {},
    );
};

/**
 * Update Button depending on what the user has selected
 *
 * @param buttonComponent - Pass the button component
 * @param state - Pass the state
 */
export const updateNotification = (notificationComponentComponent: Notification, state ) => {

    // did the user optIn at least one "Ich habe bereits"
    const hidden: boolean = state.default_notification_is_displayed;
    const notificationProperties: INotificationProperties = notificationComponentComponent.getProperties();

    notificationProperties.optHidden = !hidden;
    notificationComponentComponent.update(notificationProperties);

    if (false === notificationProperties.optHidden) {
        maletsoScan();
    }

};
